import { render } from "./ForeignTradeByCountriesBaseInfo.vue?vue&type=template&id=48208dc6&ts=true"
import script from "./ForeignTradeByCountriesBaseInfo.vue?vue&type=script&lang=ts"
export * from "./ForeignTradeByCountriesBaseInfo.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__